








import { dialogCloseEmitter } from "@/core/utils/dialog/dialogEmitter";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "AlertDialog",
  props: {
    dialogProps: Object,
  },

  setup(props, ctx) {
    const titleValue = props.dialogProps?.title;
    const contentValue = props.dialogProps?.content;

    const closeAlert = (): void => {
      dialogCloseEmitter(ctx);
    };

    return {
      titleValue,
      contentValue,
      closeAlert,
    };
  },
});
